import React from 'react';
import { TrackingCasePreviewTemplate } from 'themes/application/tracking-case/pages';
import { observer } from 'mobx-react';
import { TrackingCasePreviewViewStore } from 'application/tracking-case/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore) => new TrackingCasePreviewViewStore(rootStore), 'trackingCasePreviewViewStore')
@observer
class TrackingCasePreview extends React.Component {
    render() {
        return <TrackingCasePreviewTemplate {...this.props} />
    }
}

export default TrackingCasePreview;
